import axios from 'axios';
import { toast } from 'react-toastify';
import {
  EVENTS_SWAP_ACTION_STEP_BEGIN,
  EVENTS_SWAP_ACTION_STEP_SUCCESS,
  EVENTS_SWAP_ACTION_STEP_FAILURE,
  EVENTS_SWAP_ACTION_STEP_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function swapActionStep(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EVENTS_SWAP_ACTION_STEP_BEGIN,
    });

    const { projectId, version, eventId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/events/${eventId}/swap-actions`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: EVENTS_SWAP_ACTION_STEP_SUCCESS,
              data: res.data,
              eventId: eventId,
            });
            toast.success('Swapped Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: EVENTS_SWAP_ACTION_STEP_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Swapping failed: ${errMsg}`);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EVENTS_SWAP_ACTION_STEP_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Swapping failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSwapActionStepError() {
  return {
    type: EVENTS_SWAP_ACTION_STEP_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_SWAP_ACTION_STEP_BEGIN:
      return {
        ...state,
        swapActionStepPending: true,
        swapActionStepError: null,
      };

    case EVENTS_SWAP_ACTION_STEP_SUCCESS:
      let events = state.events;
      let index = events.findIndex((item) => {
        return item.uuid === action.eventId;
      });
      events[index] = action.data;
      return {
        ...state,
        swapActionStepPending: false,
        swapActionStepError: null,
        events: events,
        selectedEvent: {
          ...state.selectedEvent,
          actions: action.data,
        },
      };

    case EVENTS_SWAP_ACTION_STEP_FAILURE:
      return {
        ...state,
        swapActionStepPending: false,
        swapActionStepError: action.data.error,
      };

    case EVENTS_SWAP_ACTION_STEP_DISMISS_ERROR:
      return {
        ...state,
        swapActionStepError: null,
      };

    default:
      return state;
  }
}
